import styled from '@emotion/styled';

export const ActiveListElement = styled('li', { label: 'ActiveListElement' })`
    position: relative;
    z-index: 2;
`;
